import PodcastsTable  from './PodcastsTable';
import { Pagination } from "../../../../components";

const PaginatedPodcastsTable  = ({ pages, page, onPageChange, ...rest}: any) => {
    return (<><PodcastsTable {...rest}/><Pagination pages={pages} page={page} onPageChange={onPageChange}/></>)
}

export default PaginatedPodcastsTable;